import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { exportCurrencyConversionRateColumnDefinitions } from '../../shared/columnDefinitions/currencyConversionRates';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { sortBySeverity } from '../../shared/sortBySeverity';

export default ({
  currencyConversionRates,
  periodName,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  xlsxExport({
    sheetData: [
      {
        name: 'Currency Conversion Rates',
        columnDefinitions: exportCurrencyConversionRateColumnDefinitions,
        data: currencyConversionRates.sort(sortBySeverity),
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Metadata',
        type: SheetExportTypes.CUSTOM,
        data: [],
        options: {
          addTimestamp: true,
        },
      },
    ],
    metadata: {
      disableHeaderRendering: true,
      fileName: `Currency_Conversion_Rates_${periodName}${environmentSuffix}`,
    },
  });
};
